import React from "react";
import { useSelector } from "react-redux";
import Documentations from "../../service-steps/documentation/documentations";
import Referrals from "../../service-steps/education/referrals";

const Documentation = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    switch (subStep) {
      case 1:
        return <Referrals />;
      case 2:
        return <Documentations />;
    }
  };
  return renderStep();
};

export default Documentation;
